import { createFileRoute } from "@tanstack/react-router";
import HighmarkBcbsWnyInsurance, {
  config,
} from "@/pages/HighmarkBcbsWnyInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/highmark-bcbs-wny-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Highmark BCBS WNY TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how Highmark Blue Cross Blue Shield of Western New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro.",
        },
        {
          property: "og:title",
          content: "Highmark BCBS WNY TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how Highmark Blue Cross Blue Shield of Western New York policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/highmark-bcbs-wny-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/highmark-bcbs-wny-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HighmarkBcbsWnyInsurance />;
}
